// LoadingAnimation.js

import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import "./LoadingAnimation.css";

const LoadingAnimation = ({ setLoading }) => {
  const loadingRef = useRef();
  const titleRef = useRef();
  const subtitleRef = useRef();
  const sliderRef = useRef();

  useEffect(() => {
    const tl = gsap.timeline({
      onComplete: () => {
        setTimeout(() => setLoading(false), 250); // Adjust duration as needed
      },
    });

    tl.fromTo(
      titleRef.current,
      { y: -50, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: "power2.out" }
    )
      .fromTo(
        subtitleRef.current,
        { y: 50, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, ease: "power2.out" },
        "-=0.5"
      )
      .fromTo(
        sliderRef.current,
        { width: "0%" },
        { width: "100%", duration: 1, ease: "power2.out" },
        "-=0.5"
      );

    return () => {
      tl.kill();
    };
  }, [setLoading]);

  return (
    <div ref={loadingRef} className="loading-animation">
      <div className="title2" ref={titleRef}>
        Sharron Aubrey
      </div>
      <div className="slider2" ref={sliderRef}></div>
      <div className="subtitle2" ref={subtitleRef}>
        English Productions
      </div>
    </div>
  );
};

export default LoadingAnimation;
